module.exports = __webpack_public_path__ + "img/ehs.5fa31d40.png";